// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f62d4e0886304799cfa5","655":"c44547917c7f96784bca"}[chunkId] + ".js";
};